var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"dropdown-item",on:{"click":function($event){$event.stopPropagation();return _vm.$emit('select', _vm.value)}}},[_c('a',{class:{ mark: _vm.mark, selected: _vm.selected },attrs:{"href":"#"}},[_vm._v("\n        "+_vm._s(_vm.value.text)),_c('span',{class:{ mark: _vm.mark, selected: _vm.selected }})])])
}
var staticRenderFns = []

export { render, staticRenderFns }